export default "__VITE_ASSET__af72994f__"